/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Pdf_Page4_Replace_EisoxInputs */



/**
* | output |
* | --- |
* | "When replacing heads during maintenance, perform a software replacement from the Eisox hypervisor" |
*
* @param {Intervention_Plan_Pdf_Page4_Replace_EisoxInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_page4_replace_eisox = /** @type {((inputs?: Intervention_Plan_Pdf_Page4_Replace_EisoxInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_Page4_Replace_EisoxInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("When replacing heads during maintenance, perform a software replacement from the Eisox hypervisor")
	return /** @type {LocalizedString} */ ("En cas de remplacement de tetes th. lors de votre maintenance procédez à un remplacement informatique de la tete th. depuis l'hyperviseur Eisox")
});